export default __webpack_public_path__ + "static/media/report.a6ea9d47.svg";